import { Colors } from "@auteco/theme"
import { makeStyles } from "@material-ui/core"

const useStyles = makeStyles(() => ({
    title: {
        fontSize: 30,
        textAlign: 'center'
    },
    titleTotal: {
        height: '32px',
        position: 'absolute',
        top: '-30px',
        display: 'flex',
        alignItems: 'center',
        padding: '0 8px',
        fontWeight: 'bold',
        backgroundColor: '#FFA500',
        borderRadius: '16px'
    },
    barsContainer: {
        width: '100%',
        display: 'flex',
        justifyContent: 'center'
    },
    barContainer: {
        margin: '40px 0 0 30px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        position: 'relative'
    },
    bar: {
        height: '300px',
        width: '100px',
        marginTop: '12px',
        position: 'relative',
        borderRadius: '12px',
        overflow: 'hidden',
    },
    barEmpty: {
        background: Colors.GRAY_BACKGROUND
    },
    barColor: {
        background: `linear-gradient(to top,${Colors.GRAY_BACKGROUND}, #B4B4B4)`
    },
    barColorSelected: {
        background: 'linear-gradient(to top,  #ffca69, #FFA500)'
    },
    barTitle: {
        textTransform: 'capitalize',
        fontWeight: 'bold',
        marginTop: '8px'
    },
    infoContainer: {
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        position: 'absolute',
        top: '50%'
    }

}))

export default useStyles